import { IconButtonProps, IconButton as MuiIconButton } from "@mui/material";
import { Link, LinkProps } from "@tanstack/react-router";
import { forwardRef } from "react";

type Props = IconButtonProps;

export const IconButton = forwardRef<HTMLButtonElement, Props>(({ children, ...props }: Props, ref) => (
  <MuiIconButton ref={ref} {...props}>
    {children}
  </MuiIconButton>
));
IconButton.displayName = "Button";

export type RouterIconButtonProps = LinkProps & IconButtonProps;

export const RouterIconButton = ({ children, ...props }: RouterIconButtonProps) => {
  return (
    <MuiIconButton component={Link} {...props}>
      {children}
    </MuiIconButton>
  );
};
